.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}
.label {
  font-size: var(--text-sm);
  font-weight: 600;
}
.req {
  color: var(--color-danger);
}
.hint {
  font-size: var(--text-xs);
  color: var(--color-text-subtle);
}
.error {
  font-size: var(--text-xs);
  color: var(--color-danger);
  font-weight: 600;
}
.control {
  height: var(--control-h-md);
  width: 100%;
  padding-inline: 14px;
  background: var(--color-surface);
  border: 1.5px solid var(--color-border-strong);
  border-radius: var(--radius-md);
  color: var(--color-text);
  transition: border-color 0.15s var(--ease), box-shadow 0.15s var(--ease);
}
.control::placeholder {
  color: var(--color-text-subtle);
}
.control:hover:not(:disabled) {
  border-color: var(--color-text-subtle);
}
.control:focus-visible {
  outline: none;
  border-color: var(--color-accent-ink);
  box-shadow: 0 0 0 3px var(--color-focus);
  border-radius: var(--radius-md);
}
.control:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: var(--color-neutral-soft);
}
.control[aria-invalid='true'] {
  border-color: var(--color-danger-solid);
}
textarea.control {
  height: auto;
  min-height: 96px;
  padding-block: 10px;
  resize: vertical;
}
select.control {
  appearance: none;
  text-overflow: ellipsis;
  padding-inline-end: 40px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%239AA5B8' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 14px center;
}
[dir='rtl'] select.control {
  background-position: left 14px center;
}
/* Le contrôle ne s'étire jamais dans la colonne de l'enveloppe, même si une classe de zone
   lui donne un `flex` de disposition (cause des selects de filtres de 170px de haut). */
.field > .control {
  flex: none;
}
.withAdornment {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}
.withAdornment > .control {
  flex: 1 1 auto;
  min-width: 0;
}
